export enum EDITOR_MODE {
  SIMPLE = "simple",
  RICH = "rich",
}

export const EDITOR_MEDIA_ACCEPT = {
  audio: "audio/*,audio/mp3",
  image: "image/*",
  video: "video/*,.mkv",
};

export enum EditorMediaType {
  Image = "image",
  Video = "video",
  Audio = "audio",
}

export enum EDITOR_MEDIA_TAB {
  Emoji = "emoji",
  Poll = "poll",
  Embed = "embed",
}
